import { NgModule } from '@angular/core';
import { BaseTableComponent } from './base-table/base-table.component';
import { BaseLoaderComponent } from './base-loader/base-loader.component';
import { TableModule } from 'primeng/table';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import { CalendarModule } from 'primeng/calendar';
import { SliderModule } from 'primeng/slider';
import { DialogModule } from 'primeng/dialog';
import { MultiSelectModule } from 'primeng/multiselect';
import { ContextMenuModule } from 'primeng/contextmenu';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { InputTextModule } from 'primeng/inputtext';
import { ProgressBarModule } from 'primeng/progressbar';
import { DropdownModule } from 'primeng/dropdown';
import { CheckboxModule } from 'primeng/checkbox';
import { RadioButtonModule } from 'primeng/radiobutton';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { BaseFormComponent } from './base-form/base-form.component';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TooltipModule } from 'primeng/tooltip';
import { TabViewModule } from 'primeng/tabview';
import { ColorPickerModule } from 'primeng/colorpicker';
import { InputNumberModule } from 'primeng/inputnumber';
import { FileUploadModule } from 'primeng/fileupload';
import { ChartModule } from 'primeng/chart';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ComponentModule } from '../components/component.module';
import { EntityFormComponent } from './base-table/entity-form/entity-form.component';
import { CommentComponent } from './comment/comment.component';
import { ExcelUploadFormComponent } from './base-table/excel-upload-form/excel-upload-form.component';
import { BaseChartComponent } from './base-chart/base-chart.component';
import { CustomActionDirective } from './base-table/custom-action/custom-action.directive';
import { CustomActionComponent } from './base-table/custom-action/custom-action.component';
import { CamelProperPipe } from './camel-proper.pipe';
import { BmPanelDirective } from './base-menu-panel/bm-panel.directive';
import { BaseMenuPanelComponent } from './base-menu-panel/base-menu-panel.component';
import { TreeModule } from 'primeng/tree';
import { MenuBase } from './base-menu-panel/menu-base';
import { BaseService } from './base.service';
import { EditorModule } from 'primeng/editor';
import { PanelMenuModule } from 'primeng/panelmenu';
import { RippleModule } from 'primeng/ripple';
import { DateTimePipe } from './date-time.pipe';
import { RatingModule } from 'primeng/rating';
import { PickListModule } from 'primeng/picklist';
import { CardModule } from 'primeng/card';
import { SelectButtonModule } from 'primeng/selectbutton';
import { BaseCronComponent } from './base-cron/base-cron.component';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { AccordionModule } from 'primeng/accordion';
import { InputSwitchModule } from 'primeng/inputswitch';
import { UserAutoCompleteComponent } from 'src/app/base/user-auto-complete/user-auto-complete.component';
import { FileUploadControlValueAccessorDirective } from 'src/app/base/FileUploadControlValueAccessorDirective';
import { LoadingDirective } from 'src/app/core/directives/loading.directive';
import { CharacterLimitDirective } from 'src/app/core/directives/character-limit.directive';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [
    LoadingDirective,
    CharacterLimitDirective,
    BaseTableComponent,
    BaseFormComponent,
    EntityFormComponent,
    CommentComponent,
    ExcelUploadFormComponent,
    BaseChartComponent,
    CustomActionDirective,
    CustomActionComponent,
    CamelProperPipe,
    BaseMenuPanelComponent,
    BmPanelDirective,
    MenuBase,
    DateTimePipe,
    BaseLoaderComponent,
    BaseCronComponent,
    UserAutoCompleteComponent,
    FileUploadControlValueAccessorDirective,
  ],
  imports: [
    ComponentModule,
    ChartModule,
    ReactiveFormsModule,
    FormsModule,
    TableModule,
    CalendarModule,
    SliderModule,
    DialogModule,
    MultiSelectModule,
    ContextMenuModule,
    ButtonModule,
    FileUploadModule,
    ToastModule,
    InputTextModule,
    ProgressBarModule,
    DropdownModule,
    CheckboxModule,
    RadioButtonModule,
    InputNumberModule,
    InputTextareaModule,
    ConfirmDialogModule,
    TooltipModule,
    TabViewModule,
    ColorPickerModule,
    EditorModule,
    RatingModule,
    PickListModule,
    PanelMenuModule,
    TreeModule,
    RippleModule,
    CardModule,
    SelectButtonModule,
    AutoCompleteModule,
    AccordionModule,
    InputSwitchModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
      isolate: false,
    }),
  ],
  providers: [MessageService, ConfirmationService, BaseService],
  exports: [
    LoadingDirective,
    CharacterLimitDirective,
    BaseChartComponent,
    BaseTableComponent,
    BaseFormComponent,
    BaseLoaderComponent,
    CommentComponent,
    ExcelUploadFormComponent,
    EntityFormComponent,
    TranslateModule,
    CamelProperPipe,
    BaseMenuPanelComponent,
    FileUploadModule,
    TableModule,
    ChartModule,
    ReactiveFormsModule,
    FormsModule,
    CalendarModule,
    SliderModule,
    RatingModule,
    PickListModule,
    DialogModule,
    MultiSelectModule,
    ContextMenuModule,
    ButtonModule,
    ToastModule,
    InputTextModule,
    ProgressBarModule,
    DropdownModule,
    CheckboxModule,
    RadioButtonModule,
    InputNumberModule,
    InputTextareaModule,
    ConfirmDialogModule,
    TooltipModule,
    TabViewModule,
    ColorPickerModule,
    EditorModule,
    PanelMenuModule,
    TreeModule,
    RippleModule,
    CardModule,
    SelectButtonModule,
    DateTimePipe,
    BaseCronComponent,
    AutoCompleteModule,
    AccordionModule,
    InputSwitchModule,
    UserAutoCompleteComponent,
    FileUploadControlValueAccessorDirective,
  ],
})
export class BaseModule {
  //TODO
}
